import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  IconButton,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import Button from '../Button'; // Reuse your existing custom Button component

function AdministratorDeleteModal(props) {
  const {
    open,
    administrator,
    onClose,
    onDelete,
    classes: { modal },
  } = props;

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    if (open) {
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
    } else {
      html.style.overflow = '';
      body.style.overflow = '';
    }

    return () => {
      html.style.overflow = '';
      body.style.overflow = '';
    };
  }, [open]);

  return (
    <Dialog fullWidth open={open} onClose={onClose} classes={{ paper: modal }}>
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <h2>Delete Administrator</h2>
          </Grid>
          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <Typography>
          Are you sure you want to delete{' '}
          <strong>{administrator?.name || 'this administrator'}</strong>?
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="default" variant="outlined">
          No
        </Button>
        <Button
          onClick={() => onDelete(administrator)}
          color="secondary"
          variant="contained"
        >
          Yes, Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const styles = () => ({
  modal: {
    maxWidth: '500px',
  },
});

AdministratorDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  administrator: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default withStyles(styles)(AdministratorDeleteModal);
